import React from "react";
import ReactDOM from "react-dom";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
const { compose, withProps, lifecycle } = require("recompose");
const { withScriptjs } = require("react-google-maps");
const {
    StandaloneSearchBox
} = require("react-google-maps/lib/components/places/StandaloneSearchBox");

const PlacesWithStandaloneSearchBox = compose(
    withProps({
        googleMapURL:
            "https://maps.googleapis.com/maps/api/js?key=AIzaSyCrFkoy3GLop2K12MeTHY0hwwvj8M_LToY&v=3.exp&libraries=geometry,drawing,places",
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `400px` }} />
    }),
    lifecycle({
        componentWillMount() {
            const refs = {};

            this.setState({
                places: [],
                onSearchBoxMounted: ref => {
                    refs.searchBox = ref;
                },
                onPlacesChanged: () => {
                    const places = refs.searchBox.getPlaces();

                    this.props.onSearchBoxSelection(places.map(elem => {
                        let loc = elem.geometry.location;
                        return {lat: loc.lat(), lng: loc.lng()}
                    })[0]);

                    this.setState({
                        places
                    });


                }
            });
        }
    }),
    withScriptjs
)(props => (
    <div data-standalone-searchbox="">
        <StandaloneSearchBox
            ref={props.onSearchBoxMounted}
            bounds={props.bounds}
            onPlacesChanged={props.onPlacesChanged}
        >
            <TextField
                id="standard-name"
                label="Location"
                // className={classes.textField}
                // value={' '}
                // onChange={handleChange('name')}
                inputProps={{placeholder: 'Search', style: {paddingLeft: '10px'}}}
                margin="normal"
            />
        </StandaloneSearchBox>
        {/*<ol>*/}
        {/*    {props.places.map(*/}
        {/*        ({ place_id, formatted_address, geometry: { location } }) => (*/}
        {/*            <li key={place_id}>*/}
        {/*                {formatted_address}*/}
        {/*                {" at "}*/}
        {/*                ({location.lat()}, {location.lng()})*/}
        {/*            </li>*/}
        {/*        )*/}
        {/*    )}*/}
        {/*</ol>*/}
    </div>
));

export default PlacesWithStandaloneSearchBox;
